import i18n from "../i18n";
import React, { useEffect, useState } from "react";

export default function BackOnline() {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const handler = () => {
            setShow(true);
            setTimeout(() => setShow(false), 3000);
        };
        window.addEventListener('ajfarm:back-online', handler);
        return () => window.removeEventListener('ajfarm:back-online', handler);
    }, []);
    if (!show) return null;
    return (
        <div className="fixed top-2 left-1/2 -translate-x-1/2 z-[70] flex items-center gap-2 rounded-full bg-emerald-600 text-white px-4 py-1.5 shadow-lg text-sm font-semibold">
            {i18n.t("final.b9e04d3e4d00")}
        </div>
    );
}
